import Banner from "../Banner";

import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";

const BannerCarousel = ({ slides }) => {
  const allSlides = slides.flatMap(slide => {
    const mainSlide = { ...slide, all_images: null }; // Main slide stays as is
    
    const additionalImages = (slide.images || []).map(img => img.image_path);
    const groupedAdditional = [];
    
    // Group additional images in pairs (2 by 2)
    for (let i = 0; i < additionalImages.length; i += 2) {
      const group = additionalImages.slice(i, i + 2);
      groupedAdditional.push({
        ...slide,
        id: `${slide.id}-group-${i}`,
        image_path: null,
        all_images: group,
        text: "", // Trigger photo-only mode
      });
    }

    return [mainSlide, ...groupedAdditional];
  });

  const slideOptions = {
    type: "fade",
    rewind: true,
    autoplay: true,
    interval: 5000,
    speed: 1000,
    pauseOnHover: true,
    arrows: true,
    pagination: true,

    classes: {
      pagination: "splide__pagination premium-pagination",
      page: "splide__pagination__page premium-page",
    },
  };

  return (
    <div style={{ background: "#f8f9fa", position: "relative" }}>
      {allSlides.length > 0 && (
        <Splide options={slideOptions} aria-label="banners guaritas">
          {allSlides.map((slide, i) => (
            <SplideSlide key={i}>
              <Banner data={slide} />
            </SplideSlide>
          ))}

          <div className="splide__arrows premium-arrows">
            <button className="splide__arrow splide__arrow--prev">
              <span className="material-symbols-rounded">arrow_back_ios_new</span>
            </button>
            <button className="splide__arrow splide__arrow--next">
              <span className="material-symbols-rounded">arrow_forward_ios</span>
            </button>
          </div>
        </Splide>
      )}
    </div>
  );
};

export default BannerCarousel;
